// extracted by mini-css-extract-plugin
export var printerCard = "_ai-1";
export var printerCardConfigured = "_ai-2";
export var printerCardError = "_ai-3";
export var printerCardsContainer = "_ai-0";
export var printerIcon = "_ai-8";
export var printerIconConfigured = "_ai-5";
export var printerIconContainer = "_ai-4";
export var printerIconError = "_ai-6";
export var printerIconUnconfigured = "_ai-7";